import { createAction } from '@reduxjs/toolkit';
import { set_payment_gateway } from '../confg';

export const set_payment_gateway_action = createAction(set_payment_gateway);
